import React from 'react';
import getClassNames from '../../Utils/getClassNames';
import InformationPopover from './InformationPopover';

const Checkbox = (props) => {
    const handleOnChange = (e) => {
        if (props.onChange) {
            props.onChange(e.target.checked);
        }
    };

    return (
        <div className="row">
            <div className="col-auto">
                <div className="form-check">
                    {props.label && <label className={getClassNames('form-check-label', props.labelClassName)} htmlFor={props.id}>{props.label}</label>}
                    <input className={getClassNames('form-check-input', props.className)}
                        type="checkbox"
                        value={props.value}
                        id={props.id}
                        name={props.name || props.id}
                        checked={props.value}
                        onChange={handleOnChange} />
                </div>
            </div>
            {props.information && (<div className="col-auto">
                <InformationPopover content={props.information} />
            </div>)}
        </div>
    )
};

export default Checkbox;